import { FC } from "react";
import NoReportSVG from "./noreport";
import "./styles.css";

interface NoReportFoundProps {
  text?: string;
}

const NoReportFound: FC<NoReportFoundProps> = ({ text }) => {
  return (
    <div>
      <NoReportSVG dynamicText={text} />
    </div>
  );
};

export default NoReportFound;
